import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import SecondLoader from "../SecondLoader";
import AddCustomURLSchema from "../../utils/SchemasValidation/AddCustomURLSchema";
import ValidateSchema from "../../helpers/ValidateSchema";
// import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import FormInput from "../../components/Forms/FormInput";
import { trackEvent } from "../../utils/mixpanel";
import { useLocation } from "react-router-dom";

const CustomURLSAddEditModal = ({
  loading,
  data,
  setSelectedData,
  handleSaveShowModal,
  handleCloseModal,
  show,
}) => {
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setSelectedData({ ...data, [name]: value });
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(data, AddCustomURLSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const teamIdFromURL = searchParams.get("team_id");
  const userIdFromURL = searchParams.get("user_id");

  let source = "Function Page";
  if (dynamicQRCodeId) {
    source = "QR Code";
  } else if (teamIdFromURL && userIdFromURL) {
    source = "Team Member Function Page";
  }

  const handleAddUrl = async (e) => {
    if (!validateForm()) return;
    handleSaveShowModal(data);
  };

  // Handle Update
  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header className="modalHeader d-flex justify-content-between">
          <span className="modalHeading">
            {data?.isNew ? "Add" : "Edit "} Custom URL
          </span>
          <div className="modalGradientCircle"></div>
          <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          />
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            <Modal.Body>
              <div className="container-fluid px-3">
                <div className="mb-3">
                  <FormInput
                    type="text"
                    label="Title"
                    placeholder="Enter Title"
                    name="title"
                    value={data.title}
                    onChange={handleChange}
                    error={errors?.title}
                  />
                </div>

                <div className="mb-2">
                  <FormInput
                    type="text"
                    label="URL"
                    placeholder="Enter URL"
                    name="url_path"
                    value={data.url_path}
                    onChange={handleChange}
                    error={errors?.url_path}
                  />
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <div className="btnWrapper">
                <Button
                  type="button"
                  onClick={() => {
                    handleCloseModal();
                    setErrors({});
                  }}
                  variant="outline-primary"
                  className="cancelBtn mx-3"
                >
                  Cancel
                </Button>

                <Button
                  type="button"
                  onClick={handleAddUrl}
                  className="saveBtn"
                >
                  Save
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default CustomURLSAddEditModal;
